// extracted by mini-css-extract-plugin
export var header = "_t1-1";
export var maskBottom = "_t1-6";
export var maskMiddle = "_t1-7";
export var maskTop = "_t1-5";
export var root = "_t1-0";
export var scrollDownButton = "_t1-3";
export var scrollDownButtonHidden = "_t1-4";
export var viewport = "_t1-2";